import { SALON_STAFF_API_SEARCH } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  SalonStaffModel,
  SearchSalonStaffRequestModel,
} from "./salon-staff.models";

export const getStaffListByServiceIds = async (
  requestModel: SearchSalonStaffRequestModel
) => {
  return await apiClient.postHttp<SalonStaffModel[]>(
    SALON_STAFF_API_SEARCH,
    requestModel,
    undefined,
    false
  );
};
